import {
	IconButton,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Text,
} from '@chakra-ui/react';
import { IconFilter } from '@tabler/icons';
import { IFilterBody } from 'components/filter/models/TableFilterModels';

import { sxMenuFilter } from './constants/StylesMenuFilter';

interface IMenuFilterProps {
	dataTest?: string;
	filtersMap: IFilterBody[];
	selectedItems: string[];
	handleFilterToggle: (itemId: string) => void;
}

export const MenuFilter = ({
	dataTest,
	filtersMap,
	handleFilterToggle,
	selectedItems,
}: IMenuFilterProps) => {
	const filterOptions: JSX.Element[] = filtersMap
		.filter(
			(column: IFilterBody) => !selectedItems.includes(column.column_name)
		)
		.map((column: IFilterBody, index: number) => (
			<MenuItem
				data-test={column.dictionary_column_name}
				key={`${column.column_name}_${index}`}
				onClick={() => handleFilterToggle(column.column_name)}
				_hover={{ bg: 'easyBrandMenu.200' }}
				_focus={{ bg: 'easyBrandMenu.200' }}
			>
				{column.dictionary_column_name}
			</MenuItem>
		));
	return (
		<Menu>
			<MenuButton
				data-test={dataTest}
				as={IconButton}
				aria-label='Opções de filtro'
				icon={<IconFilter />}
				color={'easyBLUE.300'}
				border={'1px solid'}
				borderColor='easyBrandMenu.200'
				variant='ghost'
			/>
			<MenuList
				data-test={'menu_list-options-filter'}
				color={'easyBLUE.300'}
				boxShadow={'14px 17px 40px 4px rgba(112, 144, 176, 0.08)'}
				maxHeight={'xs'}
				overflowY='auto'
				sx={sxMenuFilter}
			>
				{filterOptions.length > 0 ? (
					filterOptions
				) : (
					<Text
						p={2}
						color={'easyBLUE.300'}
					>
						Não existem filtros disponíveis para seleção.
					</Text>
				)}
			</MenuList>
		</Menu>
	);
};
